;(function(Backbone, EG, _) {
  'use strict';
  var captchaDefaultFields;
  captchaDefaultFields = {
    captcha_enabled: undefined,
    captcha_content: undefined,
    captcha_correct: undefined,
    captcha_validation_url: undefined
  };
  EG.Users.Models.CompanyCreateUser = Backbone.Model.extend({
    initialize: function() {
      this.setDefaults();
    },
    resetData: function() {
      this.setDefaults();
    },

    setInviteCode: function(inviteCode) {
      this.set('invite_code', inviteCode);
    },

    setStatus: function(statusCode) {
      this.set('status_code', statusCode);
    },

    setDOB: function(dateOfBirth) {
      this.set('date_of_birth', dateOfBirth);
    },
    setDefaults: function(){
      var defaults = EG.Users.Constants.user_defaults;
      if (EG.Users.Utils.isGlobalGuestUserType(EG.Users.Constants.user_type)) {
        defaults['type'] = 'GLOBAL_GUEST';
      }
      this.set(defaults);
    }
  });

  EG.Users.Models.CaptchaFields = Backbone.Model.extend({
    defaults: {
      captchaEnabled: '',
      captchaContent: '',
      captchaCorrect: '',
      captchaValidationUrl: ''
    },
    initialize: function() {
      this.setData(captchaDefaultFields);
    },

    setData: function(attrs) {
      var captchaEnabled = attrs.captcha_enabled,
        captchaContent = attrs.captcha_content,
        captchaCorrect = attrs.captcha_correct,
        captchaValidationUrl = attrs.captcha_validation_url;
      // Copy snake case fields to camel case and clear the snake case ones from model
      this.clear({ silent: true });
      this.set({
        captchaEnabled: captchaEnabled,
        captchaContent: captchaContent,
        captchaCorrect: captchaCorrect,
        captchaValidationUrl: captchaValidationUrl
      });
      return this;
    },

    resetData: function() {
      this.clear({ silent: true });
    }
  });
})(Backbone, EG, _);
